import initGlide from "./initGlide";
document.addEventListener("DOMContentLoaded", () => {
    console.info("Adding legacy support for KET blocks");
    supportKetCarousel();
    supportKetTabs();
});
export function supportKetCarousel() {
    console.info("adding support for KET Carousel blocks");
    const carousels = document.querySelectorAll(".wp-block-ket-blocks-ket-carousel-new");
    let carouselIndex = 0;
    carousels.forEach(carousel => {
        let slidesPerView = 3; // default value
        const slideOffsetMatch = carousel.classList.value.match(/slideoffset-(\d+)/);
        if (slideOffsetMatch) {
            slidesPerView = parseInt(slideOffsetMatch[1]);
        }
        carousel.classList.add(`carousel-index-${carouselIndex}`);
        initGlide(carouselIndex, slidesPerView);
        carouselIndex++;
    });
}
export function supportKetTabs() {
    console.info("adding support for KET Tabs blocks");
    // First find all tabContainers on the page
    const tabContainers = document.querySelectorAll(".wp-block-ket-blocks-ket-tabbed-interface");
    // Then update the classes necessary for styling
    tabContainers.forEach(container => {
        container.classList.add("tabs");
        const nav = container.querySelector(".TabsList-root");
        if (!nav) {
            console.warn("Could not convert tabbed interface: Missing navigation element");
            return;
        }
        const tabs = nav.nextElementSibling;
        if (!tabs) {
            console.warn("Could not convert tabbed interface: Missing tabs element");
            return;
        }
        // Update classes of the navigation
        nav.classList.add("tab-navigation");
        nav.querySelectorAll("button.Tab-root").forEach(tabsListItem => {
            tabsListItem.classList.add("tab-button");
            // if button also has active-tab class, add it to the button
            if (tabsListItem.classList.contains("active-tab")) {
                tabsListItem.classList.add("active");
            }
        });
        // Update classes for the tabs themselves
        tabs.classList.add("tab-content");
        tabs.querySelectorAll(".TabPanel-root").forEach(tabPanel => {
            tabPanel.classList.add("single-tab");
            // if panel also has active-tab class, add it to the panel
            if (tabPanel.classList.contains("active-tab")) {
                tabPanel.classList.add("active");
            }
        });
        // Now add the event listeners for functionality
        const tabButtons = nav.querySelectorAll(".tab-button");
        const tabPanels = tabs.querySelectorAll(".single-tab");
        tabButtons.forEach((button, idx) => {
            button.addEventListener("click", () => {
                // Deactivate all buttons and panels
                tabButtons.forEach(btn => btn.classList.remove("active"));
                tabPanels.forEach(panel => panel.classList.remove("active"));
                // Activate the clicked button and corresponding panel
                button.classList.add("active");
                if (tabPanels[idx]) {
                    tabPanels[idx].classList.add("active");
                }
            });
        });
    });
}
